export default function Contact() {
  return (
    <section id="contact" className="py-24 px-4 bg-gradient-to-b from-orange-50 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Свяжись с Нами
          </h2>
          <p className="text-lg text-gray-600">
            Мы всегда рады помочь и ответить на твои вопросы
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          <div className="space-y-8">
            <div className="flex items-start gap-4">
              <div className="bg-gradient-to-br from-amber-400 to-orange-500 w-14 h-14 rounded-2xl flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Email</h3>
                <p className="text-gray-600">support@goldapple.ru</p>
                <p className="text-sm text-gray-500 mt-1">Ответим в течение 24 часов</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="bg-gradient-to-br from-amber-400 to-orange-500 w-14 h-14 rounded-2xl flex items-center justify-center flex-shrink-0">
                <i className="ri-phone-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Телефон</h3>
                <p className="text-gray-600">8 (800) 555-35-35</p>
                <p className="text-sm text-gray-500 mt-1">Бесплатный звонок по России</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="bg-gradient-to-br from-amber-400 to-orange-500 w-14 h-14 rounded-2xl flex items-center justify-center flex-shrink-0">
                <i className="ri-map-pin-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Адрес</h3>
                <p className="text-gray-600">Москва, ул. Тверская, д. 1</p>
                <p className="text-sm text-gray-500 mt-1">Головной офис</p>
              </div>
            </div>

            <div className="pt-6">
              <h3 className="text-xl font-bold text-gray-800 mb-4">Мы в соцсетях</h3>
              <div className="flex gap-4">
                <a 
                  href="#" 
                  className="bg-gradient-to-br from-amber-400 to-orange-500 w-12 h-12 rounded-full flex items-center justify-center hover:scale-110 transition-transform cursor-pointer"
                >
                  <i className="ri-telegram-line text-2xl text-white"></i>
                </a>
                <a 
                  href="#" 
                  className="bg-gradient-to-br from-amber-400 to-orange-500 w-12 h-12 rounded-full flex items-center justify-center hover:scale-110 transition-transform cursor-pointer"
                >
                  <i className="ri-instagram-line text-2xl text-white"></i>
                </a>
                <a 
                  href="#" 
                  className="bg-gradient-to-br from-amber-400 to-orange-500 w-12 h-12 rounded-full flex items-center justify-center hover:scale-110 transition-transform cursor-pointer"
                >
                  <i className="ri-vk-line text-2xl text-white"></i>
                </a>
                <a 
                  href="#" 
                  className="bg-gradient-to-br from-amber-400 to-orange-500 w-12 h-12 rounded-full flex items-center justify-center hover:scale-110 transition-transform cursor-pointer"
                >
                  <i className="ri-youtube-line text-2xl text-white"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-3xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-800 mb-6">Отправь сообщение</h3>
            <form className="space-y-4">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Имя
                </label>
                <input
                  type="text"
                  className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-orange-500 focus:outline-none transition-colors text-sm"
                  placeholder="Твоё имя"
                />
              </div>
              
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Email
                </label>
                <input
                  type="email"
                  className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-orange-500 focus:outline-none transition-colors text-sm"
                  placeholder="your@email.com"
                />
              </div>
              
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Сообщение
                </label>
                <textarea
                  rows={4}
                  className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-orange-500 focus:outline-none transition-colors resize-none text-sm"
                  placeholder="Твоё сообщение..."
                ></textarea>
              </div>
              
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-amber-500 to-orange-500 text-white py-3 rounded-xl font-semibold hover:from-amber-600 hover:to-orange-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Отправить
              </button>
            </form>
          </div>
        </div>

        <div className="mt-16 text-center">
          <p className="text-gray-600">
            © 2024 Золотое Яблоко. Все права защищены.
          </p>
          <div className="mt-4 flex justify-center gap-6 text-sm">
            <a href="#" className="text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
              Политика конфиденциальности
            </a>
            <a href="#" className="text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
              Условия использования
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
